if (!customElements.get('upsell-variants')) {
  class UpsellVariants extends HTMLElement {
    constructor() {
      super();

      this.handleChangeRef = this.handleChange.bind(this);
    }

    handleChange(event) {
      document.dispatchEvent(new CustomEvent('alexa:upsell-variant-change', { detail: { input: event.target, title: event.target.getAttribute('data-title'), productId: this.getAttribute('data-product-id') } }));
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChangeRef);
    }

    connectedCallback() {
      this.addEventListener('change', this.handleChangeRef);
    }
  }

  customElements.define('upsell-variants', UpsellVariants);
}
